import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { getThreeWeeks } from '@/utils/weeks';
import moment from 'moment';

const now = moment();

const initialState = {
  today: now,
  weeks: getThreeWeeks(now),
  selectedDay: now,
  activedWeekIndex: 1,
  availableTimes: [],
};

const calendarModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default calendarModule;
